import { Emitter } from "pixi-particles";
import { Container } from "./container";

export class ParticleContainer extends Container {
    public emitter: Emitter;
}
